import React, { useState } from 'react';
import { Badge, Button } from '../ui';

function initials(name = '') {
  return name.split(' ').map((w) => w[0]).join('').toUpperCase().slice(0, 2);
}

const AVATAR_COLORS = ['#2A6E7F', '#1f93e0', '#3a8fa3', '#1a5568', '#0f6e56'];
function avatarColor(name = '') {
  const i = name.charCodeAt(0) % AVATAR_COLORS.length;
  return AVATAR_COLORS[i];
}

export function BookingItem({ order, onCancel, onConfirm, showActions = true }) {
  const [expanded, setExpanded] = useState(false);

  const dates = order.selectedDate?.join(', ') || '—';
  const name = order.guestName || order.userId || 'Utente app';

  return (
    <div style={{
      borderBottom: '1px solid var(--border)',
      transition: 'background 0.1s',
    }}>
      {/* Main row */}
      <div
        onClick={() => setExpanded(!expanded)}
        style={{
          display: 'flex', alignItems: 'center', gap: '12px',
          padding: '12px 0', cursor: 'pointer',
        }}
      >
        <div style={{
          width: '34px', height: '34px', borderRadius: '50%',
          background: avatarColor(name),
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '12px', fontWeight: 500, flexShrink: 0,
        }}>
          {initials(name)}
        </div>

        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '13.5px', fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {name}
          </div>
          <div style={{ fontSize: '11.5px', color: 'var(--text-muted)', marginTop: '1px', display: 'flex', alignItems: 'center', gap: '6px' }}>
            {order.quantity}× {order.serviceSelected}
            <Badge status={order.status} />
          </div>
        </div>

        <div style={{ textAlign: 'right', flexShrink: 0 }}>
          <div style={{ fontSize: '13.5px', fontWeight: 500, color: 'var(--sand)' }}>
            € {order.totalPrice}
          </div>
          <div style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '1px' }}>
            {order.selectedDate?.[0] || '—'}
          </div>
        </div>

        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{
          transform: expanded ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s',
          color: 'var(--text-muted)', flexShrink: 0,
        }}>
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Expanded details */}
      {expanded && (
        <div style={{
          padding: '0 0 14px 46px',
          display: 'flex', flexDirection: 'column', gap: '10px',
        }}>
          <div style={{
            display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px',
            background: 'var(--surface)', borderRadius: 'var(--radius-md)',
            padding: '12px', fontSize: '12px',
          }}>
            <DetailRow label="ID ordine" value={order.id?.slice(0, 8) + '…'} />
            <DetailRow label="Servizio" value={`${order.quantity}× ${order.serviceSelected}`} />
            <DetailRow label="Totale" value={`€ ${order.totalPrice}`} />
            <DetailRow label="Date" value={dates} />
            {order.notes && <DetailRow label="Note" value={order.notes} />}
          </div>

          {showActions && order.status !== 'cancelled' && (
            <div style={{ display: 'flex', gap: '8px' }}>
              {order.status === 'pending' && (
                <Button size="sm" variant="primary" onClick={() => onConfirm?.(order.id)}>
                  ✓ Conferma
                </Button>
              )}
              <Button size="sm" variant="danger" onClick={() => onCancel?.(order.id)}>
                Cancella
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function DetailRow({ label, value }) {
  return (
    <div>
      <span style={{ color: 'var(--text-muted)', display: 'block', fontSize: '10.5px', marginBottom: '2px' }}>{label}</span>
      <span style={{ color: 'var(--text-soft)' }}>{value}</span>
    </div>
  );
}

export function BookingList({ orders, onCancel, onConfirm, emptyMessage = 'Nessuna prenotazione' }) {
  if (!orders?.length) {
    return (
      <div style={{ textAlign: 'center', padding: '32px', color: 'var(--text-muted)', fontSize: '13px' }}>
        🏖️ {emptyMessage}
      </div>
    );
  }
  return (
    <div>
      {orders.map((order) => (
        <BookingItem
          key={order.id}
          order={order}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      ))}
    </div>
  );
}
